/**
 * Auto-scroll al final de un chat cuando cambian los mensajes (o el estado
 * "pensando"). Auditoría 18/09/2026: el mismo `useEffect` +
 * `scrollIntoView({ behavior: 'smooth' })` estaba en 7 chats.
 *
 *   const endRef = useChatScroll([messages, isPending]);
 *   …
 *   <div ref={endRef} />
 */
import { useEffect, useRef, type DependencyList } from 'react';

export function useChatScroll<T extends HTMLElement = HTMLDivElement>(deps: DependencyList) {
  const endRef = useRef<T>(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return endRef;
}
